<!--<app-weekly></app-weekly>-->
<app-child-report></app-child-report>

<!--<app-admission-records></app-admission-records>-->
<!--<app-child-report-full-data></app-child-report-full-data>-->
<!--<app-weekly-reports></app-weekly-reports>-->
<!--<app-dynamic-assessment-table></app-dynamic-assessment-table>-->
